import { Entity, INotificationMessage, MessageType } from '../sockets/notification.messages';

export function eventDataState(status?: string): 'waiting' | 'processing' | 'available' | 'failed' {
  return status === 'available' || status === 'processing' || status === 'failed' ? status : 'waiting';
}

/** Dedupliceert per levering en accepteert alleen berichten uit de actieve omgeving. */
export function eventDataNoticeKey(message: INotificationMessage, club: string): string | null {
  if (!club || message.club !== club || message.entity !== Entity.Match || message.type !== MessageType.Update
      || message.payload?.eventDataStatus !== 'available' || !message.sid
      || !message.payload.eventDataProvider || !message.payload.eventDataDeliveryId) return null;
  return JSON.stringify([club, message.sid, message.payload.eventDataProvider, message.payload.eventDataDeliveryId]);
}
